import type { BdResource } from '@bindoc-projects/resource-domain-lib';
import { ShareableType } from '@bindoc-projects/resource-domain-lib';

export type AysVirtualClinicReferralImportStatus =
  'ERROR' | 'SUCCESS' | 'WAITING' | 'IN_PROGRESS';

/** A referral import as the API delivers it: the dates are ISO strings. */
export interface AysVirtualClinicReferralImportRaw {
  id: string;
  originalFileName: string;
  importCaseCount: number;
  relevantCaseCount: number;
  recipientEmailAddress: string;
  status: AysVirtualClinicReferralImportStatus;
  virtualClinicId: string;
  blobReference: { containerName: string; fileName: string };
  createdDate: string;
  modifiedDate: string;
  year: string;
}

export class AysVirtualClinicReferralImport implements BdResource {
  public static fromObj(
    obj: AysVirtualClinicReferralImportRaw,
  ): AysVirtualClinicReferralImport {
    return new AysVirtualClinicReferralImport(
      obj.id,
      obj.originalFileName,
      obj.importCaseCount,
      obj.relevantCaseCount,
      obj.recipientEmailAddress,
      obj.status,
      obj.virtualClinicId,
      obj.blobReference,
      // The API sends ISO strings; `BdResource` consumers rely on real Dates (BDA-6859).
      new Date(obj.createdDate),
      new Date(obj.modifiedDate),
      obj.year,
    );
  }

  resourceName = ShareableType.VIRTUAL_CLINIC_REFERRAL_IMPORT;

  constructor(
    public id: string,
    public name: string,
    public importCaseCount: number,
    public relevantCaseCount: number,
    public recipientEmailAddress: string,
    public status: AysVirtualClinicReferralImportStatus,
    public virtualClinicId: string,
    public blobReference: { containerName: string; fileName: string },
    public createdDate: Date,
    public modifiedDate: Date,
    public year: string,
  ) {}

  clone(): AysVirtualClinicReferralImport {
    return new AysVirtualClinicReferralImport(
      this.id,
      this.name,
      this.importCaseCount,
      this.relevantCaseCount,
      this.recipientEmailAddress,
      this.status,
      this.virtualClinicId,
      { ...this.blobReference },
      this.createdDate,
      this.modifiedDate,
      this.year,
    );
  }
}
